import { Injectable, inject } from '@angular/core';
import {
  IPagamentoFiltro,
  IRelatorioFaturamentoFiltro,
  IVincularPlanoAdmin,
} from '@nomoh-monorepo/shared-types';
import { PagamentosDataService } from './feature-pagamentos.dataservice.service';

@Injectable({ providedIn: 'root' })
export class PagamentosService {
  private pagamentosDataService = inject(PagamentosDataService);

  async carregarPagamentos(): Promise<void> {
    return this.pagamentosDataService.carregarPagamentos();
  }

  async buscarPagamentos(filtro: IPagamentoFiltro): Promise<void> {
    return this.pagamentosDataService.buscar(filtro);
  }

  async criarCheckout(params: {
    pessoaId: string;
    planoId: string;
    billingInterval?: 'month' | 'year';
  }) {
    if (!params.pessoaId || params.pessoaId.trim().length === 0) {
      throw new Error('ID da pessoa é obrigatório');
    }

    if (!params.planoId || params.planoId.trim().length === 0) {
      throw new Error('ID do plano é obrigatório');
    }

    return this.pagamentosDataService.criarCheckout(params);
  }

  async cancelarAssinatura(params: {
    pessoaId: string;
    sistemaId: string;
    imediato?: boolean;
  }) {
    if (!params.pessoaId || params.pessoaId.trim().length === 0) {
      throw new Error('ID da pessoa é obrigatório');
    }

    if (!params.sistemaId || params.sistemaId.trim().length === 0) {
      throw new Error('ID do sistema é obrigatório');
    }

    return this.pagamentosDataService.cancelarAssinatura(params);
  }

  async reativarAssinatura(params: { pessoaId: string; sistemaId: string }) {
    if (!params.pessoaId || params.pessoaId.trim().length === 0) {
      throw new Error('ID da pessoa é obrigatório');
    }

    if (!params.sistemaId || params.sistemaId.trim().length === 0) {
      throw new Error('ID do sistema é obrigatório');
    }

    return this.pagamentosDataService.reativarAssinatura(params);
  }

  async criarReembolso(params: {
    pagamentoId: string;
    amount?: number;
    reason?: string;
  }) {
    if (!params.pagamentoId || params.pagamentoId.trim().length === 0) {
      throw new Error('ID do pagamento é obrigatório');
    }

    return this.pagamentosDataService.criarReembolso(params);
  }

  async gerarRelatorioFaturamento(filtro: IRelatorioFaturamentoFiltro) {
    if (!filtro.dataInicio) {
      throw new Error('Data de início é obrigatória');
    }

    if (!filtro.dataFim) {
      throw new Error('Data de fim é obrigatória');
    }

    if (filtro.dataInicio > filtro.dataFim) {
      throw new Error('Data de início deve ser anterior à data de fim');
    }

    return this.pagamentosDataService.gerarRelatorioFaturamento(filtro);
  }

  async vincularPlanoAdmin(params: IVincularPlanoAdmin) {
    if (!params.pessoaId || params.pessoaId.trim().length === 0) {
      throw new Error('ID da pessoa é obrigatório');
    }

    if (!params.planoId || params.planoId.trim().length === 0) {
      throw new Error('ID do plano é obrigatório');
    }

    if (
      !params.gerarCobranca &&
      (!params.duracaoMeses || params.duracaoMeses <= 0)
    ) {
      throw new Error('Duração em meses é obrigatória para cortesia');
    }

    return this.pagamentosDataService.vincularPlanoAdmin(params);
  }

  async sincronizarPlanoStripe(planoId: string) {
    if (!planoId || planoId.trim().length === 0) {
      throw new Error('ID do plano é obrigatório');
    }

    return this.pagamentosDataService.sincronizarPlanoStripe(planoId);
  }

  // Navegação
  async proximaPagina(): Promise<void> {
    return this.pagamentosDataService.proximaPagina();
  }

  async paginaAnterior(): Promise<void> {
    return this.pagamentosDataService.paginaAnterior();
  }

  async irParaPagina(pagina: number): Promise<void> {
    return this.pagamentosDataService.irParaPagina(pagina);
  }

  async limparFiltros(): Promise<void> {
    return this.pagamentosDataService.limparFiltros();
  }
}
